import { DateUtils } from '@/lib/services/dateUtils';

export default {
  namespaced: true,

  state: {
    legend: {
      unstarted: { display_text: 'Not started', background_color: 'gray', soft_background_color: 'rgba(128, 128, 128, 0.1)' },
      busy: { display_text: 'Busy', background_color: '#007eff', soft_background_color: 'rgba(0, 126, 255, 0.1)' },
      finished_good: { background_color: 'green', soft_background_color: 'rgba(0, 128, 0, 0.1)' },
      finished_bad: { background_color: 'red', soft_background_color: 'rgba(255, 0, 0, 0.1)' },
    },
  },

  getters: {
    legend: (state) => state.legend,

    getGrazingColor: (state) => (grazing, farm) => {
      let color = '#222';
      if (!grazing.time_in) color = state.legend.unstarted.background_color;
      else if (!grazing.time_out) color = state.legend.busy.background_color;
      else {
        let daysAgo = DateUtils.daysBetween(new Date(), new Date(grazing.time_out));
        if (daysAgo > farm.tolerance_days.good) color = state.legend.finished_good.background_color;
        else color = state.legend.finished_bad.background_color;
      }
      return color;
    },
  },
}



// WEBPACK FOOTER //
// ./src/grazing/storeModule.js